/* istanbul ignore file - need to fix flakey tests */
import Thumbnail3D from '@components/Thumbnail3D';
import { Popover } from '@mui/material';
import { Button } from '@partful/shared/ui/Button';
import { MouseEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Object3DJSON } from 'three';
import styles from './PartsCategoriesModelViewer.module.scss';

interface PartsCategoriesModeViewerProps {
  part?: Object3DJSON;
}

export function PartsCategoriesModeViewer({ part }: PartsCategoriesModeViewerProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  // Delay rendering the canvas until the popover has fully opened to prevent canvas sizing issues
  const [shouldRenderCanvas, setShouldRenderCanvas] = useState(false);

  const { t: i18n } = useTranslation('manageProduct');

  const handlePopoverOpen = (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) =>
    setAnchorEl(event.currentTarget);
  const handlePopoverClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        data-testid="show-model"
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        size="small"
        rounded
      >
        {i18n('partsCategories.interactive.showModel')}
      </Button>

      <Popover
        data-testid="mouse-over-popover"
        id="mouse-over-popover"
        className={styles.popover}
        classes={{
          paper: styles.popoverPaper,
        }}
        TransitionProps={{
          onEntered: () => setShouldRenderCanvas(true),
          onExited: () => setShouldRenderCanvas(false),
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {shouldRenderCanvas && (
          <Thumbnail3D
            metaObject={part}
            quantity={1}
            width={240}
            height={140}
            autoRotate
            heightResizeConstant={45}
            transparent
          />
        )}
      </Popover>
    </>
  );
}
